module.exports = require("core-js-pure/stable/math/log1p");